module.exports = __webpack_public_path__ + "static/media/MacLean2014.3a7bb3a1.pdf";